import { useAssetHub } from '@/managers'
import { useAtomValue } from 'jotai'
import { ImageIcon } from 'lucide-react'
import { useState } from 'react'
import { logger } from '../../../../utilities'
import { externalCanvasDataAtom } from '../../atoms'
import { useCanvasStore } from '../../canvas-store'
import type { Layer } from '../../data/v1'
import { useDesignerActions } from '../../use-designer-actions'
import { ImageCropQuickTool } from './image-crop'
import { QuickToolButton } from './primitives'

export function ImageQuickTools(
	{ layer, layerEl }: {
		layer: Extract<Layer, { type: 'image' }>
		layerEl: HTMLElement | null
	},
) {
	const store = useCanvasStore()
	const externalData = useAtomValue(externalCanvasDataAtom, { store })
	const assetHub = useAssetHub()
	const { updateLayer } = useDesignerActions()
	const [cropActive, setCropActive] = useState(false)

	const handlePickImage = async () => {
		try {
			const asset = await assetHub.open()
			if (asset) {
				updateLayer(layer.id, { content: 'custom', customValue: asset.url })
			}
		} catch (error) {
			// The picker rejects with an AbortError when re-opened by another
			// caller — that's expected; anything else is a real failure worth
			// recording.
			if (error instanceof DOMException && error.name === 'AbortError') {
				return
			}
			logger.error(error, {
				tags: { component: 'ImageQuickTools', action: 'open-asset-hub' },
				data: { layerId: layer.id },
			})
		}
	}

	return (
		<>
			<QuickToolButton
				active={false}
				onClick={handlePickImage}
				title="Pick image"
			>
				<ImageIcon size={14} />
			</QuickToolButton>

			<ImageCropQuickTool
				layerId={layer.id}
				active={cropActive}
				onToggle={() => setCropActive(!cropActive)}
				background={layer.background}
				externalBackgroundUrl={externalData.backgroundUrl}
				layerEl={layerEl}
			/>
		</>
	)
}
